
import { Vue, Options, prop } from "vue-class-component";

class Props {
  active = prop<boolean>({ default: false, type: Boolean });
  showClear = prop<boolean>({ default: false, type: Boolean });
  showActions = prop<boolean>({ default: false, type: Boolean });
  disabledReset = prop<boolean>({ default: false, type: Boolean });
  disabledApply = prop<boolean>({ default: false, type: Boolean });
  overlayPosition = prop<string>({ default: "bottom-left", type: String });
  disabled = prop<boolean>({ default: false, type: Boolean });
}

@Options({
  emits: ["clear"],
})
export default class PillOverlay extends Vue.with(Props) {
  isOpen = false;
  toggle(): void {
    this.isOpen = !this.isOpen;
    this.$emit("toggle", this.isOpen);
  }

  close(): void {
    this.isOpen = false;
  }

  clear(): void {
    this.isOpen = false;
    this.$emit("clear");
  }

  apply(): void {
    this.isOpen = false;
    this.$emit("apply");
  }

  get overlayPositionClass(): string {
    return `pill-overlay-panel-${this.overlayPosition}`;
  }
}
